import React from 'react';
import InputMask from 'react-input-mask';
import Select from 'react-select';


export const CuitInput = (props) => {
    return <InputMask {...props} mask="99-99999999-9" maskChar=" " />;
};

export const CustomSelect = ({name, onChange, options, value, className, isSearchable, disabled, styles, isClearable}) => {
    const defaultValue = (options, value) => {
        return options ? options.find((option) => option.value === value) : '';
    };

    return (
        <div className={className}>
            <Select
                name={name}
                value={defaultValue(options, value)}
                onChange={(value) => {
                    onChange(value);
                }}
                options={options}
                isSearchable={isSearchable}
                isDisabled={disabled}
                isClearable={isClearable}
                styles={styles}
                noOptionsMessage={() => 'No se encontraron opciones'}
                placeholder={'Seleccionar'}/>
        </div>

    );
};
